module.exports = __webpack_public_path__ + "assets/icons-artesan.c753b9beda563732416fe706289f1857.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/icons-artesan.png
 ** module id = 217
 ** module chunks = 0
 **/